import { graphqlApiWithPersisted } from './graphqlApi';

interface SupabaseGenerateTokenArgs {
  channelId: number;
}

interface SupabaseGenerateTokenPayload {
  token: string;
}

interface SupabaseGenerateTokenResponse {
  data: {
    supabaseGenerateToken: {
      payload: SupabaseGenerateTokenPayload;
    };
  };
}

export const supabaseApi = graphqlApiWithPersisted.injectEndpoints({
  endpoints: (builder) => ({
    supabaseGenerateToken: builder.mutation<
      SupabaseGenerateTokenPayload,
      SupabaseGenerateTokenArgs
    >({
      query: ({ channelId }) => ({
        url: '/graphql/webapp?supabaseGenerateToken',
        method: 'POST',
        body: {
          query: `mutation SupabaseGenerateToken($input: SupabaseGenerateTokenInput!) {
            supabaseGenerateToken(input: $input) {
              payload {
                token
              }
              error {
                ... on UnknownError {
                  message
                  kind
                }
              }
            }
          }`,
          variables: { input: { channelId } },
        },
      }),
      transformResponse: (response: SupabaseGenerateTokenResponse) =>
        response.data.supabaseGenerateToken.payload,
    }),
  }),
});

export const { useSupabaseGenerateTokenMutation } = supabaseApi;
